<template>
  <div class="aside__block">
    <Head></Head>
    <Form></Form>
  </div>
</template>

<script>
import Head from './Head';
import Form from './Form';

import { mapActions } from 'vuex';

export default {
  components: { Head, Form },
  beforeMount() {
    this.$store.dispatch('auth/getCoursesForEmail');
  },
  methods: {
    ...mapActions('usersTeamMembers', ['setAsideMeta', 'setAsideData'])
  }
};
</script>
